import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { SubscriptionProviderCategoryUpdateModel } from "src/app/models/subscription/subscription-provider-category-update.model";
import { SubscriptionProviderCategorySummaryModel } from "src/app/models/subscription/subscription-prodiver-category-summary.model";

@Injectable({
  providedIn: 'root',
})
export class SubscriptionSettingsService {

  constructor(private httpClient: HttpClient) {
  }

  public getSubscriptionProviderCategorySummaries(
    subscriptionId: string
  ): Observable<SubscriptionProviderCategorySummaryModel[]> {

    return this.httpClient.get<SubscriptionProviderCategorySummaryModel[]>(
      Configuration.getApiBaseUrl() + '/subscriptionsettings/' + subscriptionId
    );
  }

  public updateSubscriptionProviderCategories(
    subscriptionId: string, models: SubscriptionProviderCategoryUpdateModel[]
  ): Observable<void> {

    return this.httpClient.post<void>(
      Configuration.getApiBaseUrl() + '/subscriptionsettings/' + subscriptionId,
      models
    );
  }
}